<template>
  <div class="ms-personal-settings">
    <ul>
        <li class="ms-settings">
            <label>昵称</label>
            <a class="text-ellipsis">
                <van-cell-group  :class="['input',focusVal==1?'on':'']" >
                    <van-field v-model="person.name" @focus="focusVal=1" @blur="saveUserInfo()" placeholder="请输入昵称" />
                </van-cell-group>
            </a>
        </li>
        <li class="ms-settings">
            <label>性别</label>
            <a @click="editShow=true" class="text-ellipsis">{{person.gender==1?'男':(person.gender==2?'女':'')}}</a>
        </li>
        <li class="ms-settings">
            <label>邮箱</label>
            <a class="text-ellipsis">
                <van-cell-group  :class="['input',focusVal==2?'on':'']">
                    <van-field v-model="person.email" @focus="focusVal=2" @blur="saveUserInfo()" placeholder="请输入邮箱" />
                </van-cell-group>
            </a>
        </li>
    </ul>
    <!-- 修改内容弹出 -->
    <van-popup v-model="editShow" position="bottom">
        <div class="editUserinfo">
            <van-picker show-toolbar :columns="columnsArr" @confirm="genderChange" />
        </div>
    </van-popup>
  </div>
</template>

<script>
import { my,save_personal } from "@/api/measurement_system"
export default {
    data(){
        return{
            bodyShow:false,
            data:{},
            person:{},
            columnsArr:['男','女'],
            editShow:false,
            focusVal:null
        }
    },
    methods:{
        /*
         *@param: 
         *@return: 
         *@Description: 提交数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-12 18:43:59
        */
        saveUserInfo(){
            this.focusVal = null;
            // loading
            this.$toast.loading({
                mask: true,
                message: "提交中..."
            });
            save_personal(this.person).then((data)=>{
                this.$toast.clear();
                if (data.code == 10002) {
                    this.$toast(data.data.msg);
                    return;
                }

                this.$toast(data.msg);
                
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description: 改变性别
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-12 18:43:42
        */
        genderChange(val){
            if(val=='男'){
                this.person.gender = 1;
            }
            if(val=='女'){
                this.person.gender = 2;
            }
            this.editShow = false;
            this.saveUserInfo();
        },
        /*
         *@param: 
         *@return: 
         *@Description: 初始化方法
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-12 17:50:05
        */
        pullData(){
            // loading
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            my().then((data)=>{
                this.data= data;
                this.person =data.person;
                this.bodyShow = true;
                this.$toast.clear();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss">
.ms-personal-settings{
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: #ffffff;
    .ms-settings{
        display: flex;
        line-height: 90px;
        align-items: center;
        padding:0 30px;
        font-size: 32px;
        color: #333333;
        border-bottom:1px solid #ccc;
        &:last-child{
            border: 0;
        }
        a{
            display: block;
            max-width: 500px;
            color: #999999;
            margin-left: auto;
            text-align: right;
        }
    }
    .editUserinfo{
      width: 100%;
      border-radius:48px 48px 0px 0px;
      background: #fff;
      padding-top: 48px;
      .input.van-cell-group{
          min-width: 300px;
      }
    }
    .input.van-cell-group{
        min-width: 400px;
        input{
            color: #999999;
            text-align: right;
        }
        .van-cell{
            padding: 20px 0;
        }
    }
    .input.van-cell-group.on{
        input{
            color: #333333;
        }
    }
}
.van-cell.van-field{
    background-color: transparent;
}
</style>